import { render } from "./legoTreePolicy.vue?vue&type=template&id=795c80b0&scoped=true"
import script from "./legoTreePolicy.vue?vue&type=script&lang=js"
export * from "./legoTreePolicy.vue?vue&type=script&lang=js"

import "./legoTreePolicy.vue?vue&type=style&index=0&id=795c80b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795c80b0"],['__file',"src/components/lego/extend/legoTreePolicy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "795c80b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('795c80b0', __exports__)) {
    api.reload('795c80b0', __exports__)
  }
  
  module.hot.accept("./legoTreePolicy.vue?vue&type=template&id=795c80b0&scoped=true", () => {
    api.rerender('795c80b0', render)
  })

}


export default __exports__